/* hs-eslint ignored failing-rules */
/* eslint-disable prefer-promise-reject-errors */

import { useCallback, useContext, useMemo } from 'react';
import { gate } from 'hub-http/gates';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import usePromiseEffect from '../../shared/hooks/usePromiseEffect';
import visualize from 'reporting-snowflake/funnel/resolve/visualize';
import { applyLimitAndOffset } from 'reporting-snowflake/funnel/utils/limitAndOffset';
const JOURNEY_DEAL_AMOUNT_DRILLDOWN = gate('ReportMigration:JourneySurfacingDealAmount');
const useDealAmountDrilldown = () => {
  const userInfo = useContext(UserInfoContext);
  return useMemo(() => userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates.includes(JOURNEY_DEAL_AMOUNT_DRILLDOWN), [userInfo]);
};
const useVisualizeJourney = (report, {
  limit,
  offset
}, datamap, onDrilldown) => {
  const hasDealAmountDrilldown = useDealAmountDrilldown();
  const constructVisualization = useCallback(() => new Promise((resolve, reject) => {
    if (!datamap) {
      reject(undefined);
      return;
    }
    resolve(visualize(report, applyLimitAndOffset(datamap, {
      limit,
      offset
    }), onDrilldown, {
      hasDealAmountDrilldown
    }));
    return;
  }), [report, limit, offset, datamap, onDrilldown, hasDealAmountDrilldown]);
  const visualState = usePromiseEffect(constructVisualization);
  return visualState;
};
export default useVisualizeJourney;